var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基础资料", name: "1" } },
            [
              _vm.activeName === "1"
                ? _c("BasicData", { attrs: { value: _vm.detailsData } })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "会员资产", name: "2" } },
            [
              _vm.activeName === "2"
                ? _c("MemberAssets", { attrs: { value: _vm.detailsData } })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "其它记录", name: "3" } },
            [
              _vm.activeName === "3"
                ? _c("OtherRecords", { attrs: { value: _vm.detailsData } })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }